module.exports = __webpack_public_path__ + "static/media/fruit_boxes.4e168289.jpg";